import { User } from '@citrite/sf-api';

export const getUserInitials = (user: User) => {
	return `${user.FirstName?.substring(0, 1) ?? ''}${
		user.LastName?.substring(0, 1) ?? ''
	}`.toUpperCase();
};

export const getUserFullName = (user: User) => {
	return `${user.FirstName ?? ''} ${user.LastName ?? ''}`;
};
